// PsyPractice: hukuki belgeler / Magyar.
//
// Bölüm sırası, başlık numaraları ve hukuki iddialar TÜM dillerde aynıdır; esasa
// ilişkin bir değişiklik bütün dillerde birlikte yapılır ve shared.ts'teki
// LEGAL_VERSION birlikte artar; aksi hâlde kullanıcının onayladığı sürüm ile
// okuduğu metin ayrışır. Yalnızca çeviri eklemek sürümü ARTIRMAZ.
import { LEGAL_VERSION, MERCHANT, type LegalDoc } from "./shared";

// İşletme türünün ADI dile bağlıdır, resmî bilgiler (ad, adres, vergi) değildir;
// bu yüzden shared.ts'te değil, her dilin kendi dosyasında durur.
const OWNER_TYPE = "egyéni vállalkozás";

const OWNER = 'PsyPractice (a továbbiakban: „Platform” vagy „Adatkezelő”)';

export const DOCS: LegalDoc[] = [
  {
    id: "terms",
    title: "Felhasználási feltételek és felelősségkizárás",
    description:
      "A szolgáltatás jellege és korlátai, mit nem helyettesít, a felhasználó kötelezettségvállalásai, valamint átfogó joglemondás, amely minden felelősséget a felhasználóra hárít.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Felek és elfogadás",
        paras: [
          `A jelen Felhasználási feltételek ${OWNER} és minden olyan természetes vagy jogi személy között jönnek létre, aki a Platformhoz hozzáfér vagy azt használja (a „Felhasználó”). A fiók létrehozásával, a bejelentkezéssel vagy a Platform bármilyen módon történő használatával a Felhasználó megerősíti, hogy a jelen Feltételeket teljes egészében elolvasta, megértette, feltétel nélkül elfogadja, és vállalja azok betartását. Aki a jelen Feltételeket nem fogadja el, nem használhatja a Platformot.`,
        ],
      },
      {
        heading: "2. A szolgáltatás jellege és korlátai",
        bullets: [
          "A PsyPractice MI-alapú páciens-SZIMULÁCIÓS szoftver, amely lehetővé teszi pszichológushallgatók és pályakezdő klinikusok számára, hogy biztonságos környezetben végezzék és rögzítsék saját beszélgetésvezetési gyakorlásukat.",
          "A PsyPractice nem oktatási vagy tanítási szolgáltatás; szoftvereszköz, amellyel a felhasználó saját gyakorlását végzi és rögzíti. A Platform nem nyújt órákat, tantervet, vizsgákat vagy dokumentumokat, és semmilyen címet, képesítést vagy jogosultságot nem ad.",
          "A szimulált „páciens” nem valódi kliens; válaszait mesterséges intelligencia állítja elő, azok hibásak, hiányosak, következetlenek vagy félrevezetők lehetnek, és semmilyen klinikai pontosságra vagy valóságtartalomra nem tartanak igényt.",
        ],
      },
      {
        heading: "2.1. Mit nem helyettesít a Platform",
        bullets: [
          "NEM valódi terápia vagy tanácsadás, és nem helyettesít egyetlen valódi klienssel folytatott ülést sem.",
          "NEM helyettesíti a klinikai szupervíziót. A szupervizor MI által készített visszajelző jelentések automatikusan generált szövegek; nem szakértői vélemények, nem hivatalos értékelések és nem osztályzatok.",
          "NEM diagnosztikai, szűrő- vagy értékelőeszköz; a Platform egyetlen kimenete sem használható valódi személyre vonatkozó diagnosztikai vagy klinikai döntéshozatalra.",
          "Krízisben vagy vészhelyzetben NEM SZABAD használni. Öngyilkossági gondolatok, önmagát vagy másokat veszélyeztető magatartás kockázata vagy bármilyen hasonló vészhelyzet esetén zárja be a Platformot, és azonnal forduljon a helyi sürgősségi szolgálathoz vagy egy illetékes egészségügyi intézményhez.",
          "NEM forrása szakmai kompetenciának, működési engedélynek, címnek vagy jogosultságnak; a Platformon eltöltött idő és annak kimenetei egyetlen intézménynél sem mutathatók be a képesítés igazolásaként.",
        ],
      },
      {
        heading: "3. A Felhasználó nyilatkozatai és kötelezettségvállalásai",
        bullets: [
          "A Felhasználó vállalja, hogy a Platformot kizárólag jogszerű és etikus keretek között, saját szakmai gyakorlatának fejlesztése céljából használja.",
          "A Felhasználó vállalja, hogy NEM visz be VALÓDI páciens- vagy kliensadatot, azonosító információt vagy bármely személyhez tartozó különleges kategóriájú egészségügyi adatot; ennek minden jogi következménye kizárólag a Felhasználót terheli.",
          "A Felhasználó vállalja, hogy a Platformról származó kimeneteket nem használja valódi személy diagnosztizálására, kezelésére, a beavatkozásra vagy a rá vonatkozó klinikai döntéshozatalra.",
          "Saját szakmai kompetenciájáért, hatásköréért, valamint a vonatkozó szakmai és etikai szabályok betartásáért kizárólag a Felhasználó felel.",
          "A fiók biztonsága, a jelszó titkossága és a Felhasználó fiókjában végzett minden tevékenység a Felhasználó felelőssége.",
          "A fiók személyes; a Felhasználó vállalja, hogy nem osztja meg másokkal, és a Platformot nem használja automatizált eszközökkel (botok, szkriptek stb.). A fizetős csomagok használatára méltányos használati korlát vonatkozik (jelenleg naptári hónaponként 60 ülés), amelyet a Távollévők közötti szerződés részletez.",
        ],
      },
      {
        heading: "4. Minden felelősség a Felhasználót terheli (joglemondás)",
        paras: [
          "A Platform „ADOTT ÁLLAPOTÁBAN” és „RENDELKEZÉSRE ÁLLÁS SZERINT” áll rendelkezésre, bármiféle kifejezett vagy hallgatólagos szavatosság nélkül (ideértve a megszakítás nélküli működést, a hibamentességet, az adott célra való alkalmasságot, a pontosságot és a naprakészséget).",
          "A Felhasználó elfogadja és vállalja, hogy KIZÁRÓLAG és SZEMÉLYESEN felel minden olyan közvetlen, közvetett, járulékos, különleges vagy következményes kárért (ideértve a vagyoni, nem vagyoni, szakmai hírnevet érintő, adatvesztésből és bevételkiesésből eredő, valamint harmadik személynek okozott károkat), amely a Platform használatából vagy használatának lehetetlenségéből, az MI-kimenetekre való hagyatkozásból vagy azok bármilyen alkalmazásából ered.",
          "Az alkalmazandó jog által megengedett legteljesebb mértékben a Felhasználó ezennel visszavonhatatlanul és feltétel nélkül, már most és előre LEMOND minden olyan igényről, keresetről és kártérítési jogról, amelyet bármilyen hátrányos kimenetel esetén az őt ért sérelem miatt a Platformmal, annak tulajdonosaival, munkavállalóival, fejlesztőivel, üzleti partnereivel és szolgáltatóival szemben érvényesíthetne.",
          "A Felhasználó továbbá vállalja, hogy a Platformot teljes mértékben mentesíti (kártalanítja) minden igény, kár, bírság és költség (ideértve az ügyvédi díjakat) alól, amennyiben a Felhasználó saját hibája, gondatlansága vagy a jelen Feltételeket sértő használata miatt bármely harmadik személy vagy intézmény a Platformmal szemben lép fel.",
        ],
      },
      {
        heading: "5. A felelősség korlátozása",
        paras: [
          "Az alkalmazandó jog kötelező rendelkezéseinek sérelme nélkül a Platform teljes jogi felelőssége minden esetben arra az összegre korlátozódik, amelyet a Felhasználó az adott igény alapjául szolgáló eseményt megelőző 12 hónapban ténylegesen fizetett a Platformnak. Ingyenes használat esetén ez az összeg nulla.",
        ],
      },
      {
        heading: "6. Szellemi tulajdon, módosítás és megszüntetés",
        bullets: [
          "A Platformhoz, annak szoftveréhez, dizájnjához, pácienseset-sablonjaihoz és tartalmához fűződő minden szellemi tulajdonjog a Platformot illeti.",
          "A Felhasználó által a Platformon létrehozott bármely tartalomhoz (ideértve az általa írt terapeutaüzeneteket, az ülésátiratokat és az ezekből származtatott anyagokat) fűződő valamennyi átruházható vagyoni szellemi tulajdonjog a tartalom létrehozásának pillanatában kizárólagosan, örökre és díjmentesen a Platformra átruházottnak tekintendő; a Platform ezt a tartalmat világszerte és korlátozás nélkül felhasználhatja, többszörözheti és feldolgozhatja bármely célra, ideértve a szolgáltatás működtetését, a visszajelzés előállítását, valamint a rendszer fejlesztését és továbbfejlesztését (ideértve a gépi tanulás útján történő fejlesztést is). Az átruházás nem érinti a Felhasználónak az alkalmazandó adatvédelmi jog (GDPR / KVKK) szerinti, személyes adatokhoz fűződő jogait, amelyek fenntartva maradnak.",
          "A Platform fenntartja a jogot, hogy a jelen Feltételeket és a szolgáltatás terjedelmét bármikor, előzetes értesítés nélkül módosítsa, felfüggessze vagy megszüntesse.",
          "A jelen Feltételek megsértése esetén a Platform a fiókot előzetes értesítés nélkül felfüggesztheti vagy megszüntetheti.",
        ],
      },
      {
        heading: "7. Irányadó jog és joghatóság",
        paras: [
          "A jelen Feltételekre a Török Köztársaság joga az irányadó. Az esetlegesen felmerülő jogviták elbírálására a Török Köztársaság bíróságai és végrehajtó hivatalai rendelkeznek joghatósággal.",
          "Az Európai Unióban lakóhellyel rendelkező fogyasztók esetében a lakóhelyük szerinti ország kötelező fogyasztóvédelmi rendelkezései által biztosított védelem és a GDPR szerinti adatvédelmi jogaik fenntartva maradnak; a jelen jogválasztás ezeket a kötelező rendelkezéseket nem írja felül.",
        ],
      },
    ],
  },
  {
    id: "privacy",
    title: "Adatvédelmi tájékoztató",
    description:
      "A GDPR mint alapstandard; a kezelt adatok, a jogalapok, az EU-s tárhely, a nemzetközi adattovábbítás (MI-szolgáltató), valamint a törökországi felhasználókra vonatkozó, KVKK 9. cikk szerinti, határon átnyúló adattovábbítási rendelkezés.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          `A jelen Adatvédelmi tájékoztató azt ismerteti, hogyan kezeljük a személyes adatokat a(z) ${OWNER} által működtetett Platformon belül. A tájékoztató adatvédelmi alapstandardként az EU általános adatvédelmi rendeletét (GDPR / 2016/679) követi; a Törökországban tartózkodó felhasználókra ezen felül a személyes adatok védelméről szóló 6698. számú török törvény (KVKK), különösen annak a külföldre továbbításról szóló 9. cikke is alkalmazandó. A KVKK adatkezelési tájékoztató és a Kifejezett hozzájárulási nyilatkozat a jelen tájékoztató szerves részét képezi.`,
        ],
      },
      {
        heading: "Adatkezelő és a tárhely helye",
        bullets: [
          "Adatkezelő: PsyPractice. Az érintetti kérelmeket a Platformon közzétett kapcsolattartási csatornán keresztül kezeljük (kapcsolattartási e-mail: info@psycora.com).",
          "Tárhely: a Platform és adatbázisa az Európai Unión belül, egy hollandiai adatközpontban (Oracle Cloud) található. Az EU/EGT területén tartózkodó felhasználók adatait az EU-n belül kezeljük és tároljuk.",
          "A tárhelyszolgáltató kizárólag adatfeldolgozóként jár el, megkötött adatfeldolgozási megállapodás (DPA) alapján.",
        ],
      },
      {
        heading: "Gyűjtött adatok",
        bullets: [
          "Fiókadatok: név, e-mail-cím, hashelt jelszó, előfizetési/csomagadatok.",
          "Használati adatok: létrehozott ülések, ülésátiratok, létrehozott páciensesetek, szupervizori visszajelző jelentések.",
          "Technikai adatok: munkamenet-nyilvántartás, IP-cím, böngésző-/nyelvi beállítás, sebességkorlátozási és biztonsági naplók.",
        ],
      },
      {
        heading: "Az adatkezelés céljai és jogalapja (GDPR 6. cikk)",
        bullets: [
          "Szerződés teljesítése (6. cikk (1) b) pont): fiók létrehozása, ülések lebonyolítása, több ülésen átívelő páciensmemória, szupervizori értékelés, előfizetés- és használatikorlát-kezelés.",
          "Jogos érdek (6. cikk (1) f) pont): biztonság, visszaélések megelőzése, a rendszer fejlesztése és hibaelhárítás.",
          "Jogi kötelezettség (6. cikk (1) c) pont): jogszabályból eredő megőrzés/jelentéstétel.",
          "Hozzájárulás (6. cikk (1) a) pont): a szolgáltatáshoz nem feltétlenül szükséges elemzési/termékfejlesztési adatkezelés, valamint szükség esetén az EU/EGT-n kívülre történő továbbítás.",
        ],
      },
      {
        heading: "Nemzetközi adattovábbítás",
        paras: [
          "Mivel a tárhely az EU-n belül (Hollandiában) található, az EU/EGT-felhasználók adatait főszabály szerint az EU-n belül kezeljük, és ezen a rétegen nem történik harmadik országba irányuló továbbítás. Az MI-válaszok előállításához azonban az ülések tartalmát és a promptokat az MI-szolgáltatónak (Anthropic) továbbítjuk, amelynek feldolgozási infrastruktúrája az EU/EGT-n kívül (pl. az Egyesült Államokban) is elhelyezkedhet.",
          "Az EU/EGT-n kívülre irányuló ilyen továbbítások a GDPR 44. és azt követő cikkei szerinti megfelelő garanciákon, különösen az Európai Bizottság általános szerződési feltételein (SCC) alapulnak, és a szolgáltatóval adatfeldolgozási megállapodást (DPA) kötünk. A Platform NEM értékesít személyes adatokat marketingcélokra; az adatokat nem osztjuk meg harmadik felekkel, kivéve, ha az a szolgáltatás működtetéséhez feltétlenül szükséges (az illetékes hatóságok jogszerű megkereséseinek fenntartásával).",
        ],
      },
      {
        heading: "Törökországi felhasználóknak: KVKK 9. cikk (külföldre továbbítás)",
        paras: [
          "A Törökországban tartózkodó felhasználók személyes adatait Törökországon kívülre továbbítjuk, mivel a tárhely Hollandiában (EU) található, és az MI-feldolgozás céljából az Anthropic részére is továbbíthatjuk. Ezek a továbbítások a KVKK 9. cikkének hatálya alá tartoznak, és megfelelő garanciákon (a Testület által közzétett általános szerződésen/kötelezettségvállaláson) vagy szükség esetén az Ön kifejezett hozzájárulásán alapulnak. A továbbítás terjedelmét, címzettjeit és célját a KVKK adatkezelési tájékoztató és a Kifejezett hozzájárulási nyilatkozat részletezi.",
        ],
      },
      {
        heading: "Az érintettek jogai (GDPR 15-22. cikk)",
        bullets: [
          "Hozzáférés, helyesbítés, törlés („az elfeledtetéshez való jog”) és az adatkezelés korlátozása.",
          "Adathordozhatóság: az Ön által megadott adatok tagolt, széles körben használt, géppel olvasható formátumban való megkapása.",
          "Tiltakozás: tiltakozás a jogos érdeken alapuló adatkezelés és a közvetlen üzletszerzés ellen.",
          "A kizárólag automatizált egyedi döntéshozatallal/profilalkotással kapcsolatos jogok.",
          "A hozzájáruláson alapuló adatkezelés esetén a hozzájárulás bármikor visszavonható (a visszavonás nem érinti az addig végzett adatkezelés jogszerűségét).",
          "Panasztételi jog a felügyeleti hatóságnál: az EU-ban az illetékes adatvédelmi hatóságnál, Törökországban a Személyes Adatok Védelmének Hatóságánál (KVKK).",
        ],
      },
      {
        heading: "Megőrzés és biztonság",
        bullets: [
          "Az adatokat addig őrizzük meg, ameddig az adatkezelés célja megkívánja, és az alkalmazandó jog által előírt ideig; az időszak lejártával töröljük vagy anonimizáljuk őket.",
          "Az érzékeny mezőket (pl. a jelszó, az ellenőrző és visszaállító kódok) titkosítva/hashelve tároljuk; a hozzáférés jogosultsághoz kötött.",
          "Mivel egyetlen továbbítási vagy tárolási módszer sem 100%-ig biztonságos, abszolút biztonság nem garantálható.",
        ],
      },
      {
        heading: "Valódi páciensadatok tilalma",
        paras: [
          "A Platform szimulációs szoftver; valódi kliensekhez tartozó személyes/egészségügyi adatok bevitele tilos. A tilalom megszegésével bevitt adatokból eredő minden felelősség kizárólag a Felhasználót terheli.",
        ],
      },
    ],
  },
  {
    id: "kvkk",
    title: "KVKK adatkezelési tájékoztató",
    description:
      "Adatkezelő, az adatkezelés céljai, jogalap, adattovábbítás és az érintettek jogai a 6698. számú törvény 10. cikke alapján.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Adatkezelő",
        paras: [
          `A személyes adatok védelméről szóló 6698. számú török törvény („KVKK”) 10. cikke alapján az Ön személyes adatait ${OWNER} adatkezelői minőségében, az alábbiakban leírt keretek között kezeli.`,
        ],
      },
      {
        heading: "Kezelt adatok és célok",
        bullets: [
          "Azonosító/kapcsolattartási adatok (név, e-mail-cím): fiók létrehozása, hitelesítés, kapcsolattartás.",
          "Ügyféltranzakciós adatok (előfizetés, csomag, használat): szolgáltatásnyújtás, számlázás, a korlátok érvényesítése.",
          "Tranzakcióbiztonsági adatok (munkamenet, IP-cím, naplók): biztonság, visszaélések megelőzése, jogi kötelezettség.",
          "Felhasználói tartalom (ülésátiratok, létrehozott esetek): a szoftverszolgáltatás nyújtása és a visszajelzés előállítása.",
          "Intézményi csoporttagság (csoportazonosító, tagsági időszak): ha a felhasználó egy intézmény által működtetett csoporthoz csatlakozik, az oktatói betekintés és a csoport adminisztrációja.",
        ],
      },
      {
        heading: "Jogalap (5. cikk)",
        bullets: [
          "Szerződés megkötése/teljesítése: a szolgáltatás nyújtásához szükséges adatok.",
          "Az adatkezelő jogos érdeke: biztonság, csalásmegelőzés, a rendszer fejlesztése.",
          "Jogi kötelezettség: jogszabályból eredő megőrzés/jelentéstétel.",
          "Kifejezett hozzájárulás: külföldre továbbítás (9. cikk) és a szolgáltatáshoz nem feltétlenül szükséges további adatkezelés.",
        ],
      },
      {
        heading: "Külföldre továbbítás (9. cikk)",
        paras: [
          "Mivel a Platform és adatbázisa az Európai Unión belül, egy hollandiai adatközpontban (Oracle Cloud) található, a Törökországban tartózkodó felhasználók személyes adatait Törökországon kívülre (az EU-ba) továbbítjuk. Emellett az MI-válaszok előállításához az ülések tartalma és a promptok az MI-szolgáltató (Anthropic) részére is továbbíthatók, amelynek feldolgozási infrastruktúrája az EU/EGT-n kívül (pl. az Egyesült Államokban) is elhelyezkedhet.",
          "Ezek a külföldre irányuló továbbítások a KVKK 9. cikkének hatálya alá tartoznak, és megfelelő garanciákon, például a Testület által közzétett általános szerződésen/kötelezettségvállaláson, vagy szükség esetén az Ön kifejezett hozzájárulásán alapulnak. A tárhely- és egyéb szolgáltatókkal adatfeldolgozási megállapodásokat (DPA) kötünk.",
        ],
      },
      {
        heading: "Intézményi csoportok és oktatói betekintés",
        paras: [
          "Ha egyetem, klinika vagy hasonló intézmény által nyitott csoporthoz csatlakozik, az ülései tartalmát (átiratok) és a szupervizori jelentéseket a csoport oktatója a csoport időtartama alatt láthatja. Ez a betekintés kizárólag a csoporthoz kapcsolódó üléseire terjed ki, és a csoporttagság megszűnésével véget ér.",
          "Ez a hozzáférés a csoporthoz való csatlakozáskor megjelenő KÜLÖN kifejezett hozzájárulási képernyőn keresztül jön létre; nem része a Platform általános elfogadásának. Ha ezt a hozzájárulást nem adja meg, nem csatlakozhat a csoporthoz, de a Platformot egyénileg, változatlanul tovább használhatja. A hozzájárulás visszavonása megszünteti a csoporttagságot, és nem érinti az egyéni használatot.",
        ],
      },
      {
        heading: "Az érintettek jogai (11. cikk)",
        bullets: [
          "Megtudni, hogy személyes adatait kezelik-e, és ha igen, tájékoztatást kérni erről.",
          "Megismerni az adatkezelés célját, és azt, hogy az adatokat e célnak megfelelően használják-e.",
          "Megismerni azokat a harmadik feleket, akiknek az adatokat belföldön vagy külföldön továbbítják.",
          "Kérni a hiányos/hibás adatkezelés helyesbítését, és a feltételek fennállása esetén az adatok törlését/megsemmisítését.",
          "Tiltakozni az Önre nézve hátrányos, kizárólag automatizált elemzésen alapuló eredmény ellen.",
          "Kártérítést követelni a jogellenes adatkezelés miatt elszenvedett kárért.",
        ],
      },
      {
        heading: "Kérelmek",
        paras: [
          "A jogaival kapcsolatos kérelmeit az Adatkezelő által közzétett kapcsolattartási csatornán nyújthatja be. A kérelmeket a KVKK-ban és a végrehajtási jogszabályokban előírt határidőn belül bíráljuk el.",
        ],
      },
    ],
  },
  {
    id: "consent",
    title: "Kifejezett hozzájárulási nyilatkozat",
    description:
      "Az adatkezelési tájékoztatótól elkülönítve; szabadon adott hozzájárulás a külföldre továbbításhoz és az MI-feldolgozáshoz.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "Kijelentem, hogy a KVKK adatkezelési tájékoztatót elolvastam és megértettem, és szabadon, tájékozottan és kifejezetten hozzájárulok az alább leírt adatkezeléshez. (A KVKK Testület 2018/90. számú határozata alapján a kifejezett hozzájárulást a tájékoztatási kötelezettségtől elkülönítve kell beszerezni.)",
        ],
      },
      {
        heading: "Az adatkezelés, amelyhez hozzájárulok",
        bullets: [
          "Személyes adataim Törökországon kívülre továbbítása, ottani tárolása és kezelése, mivel a Platform az Európai Unióban (Hollandia / Oracle Cloud) van elhelyezve (KVKK 9. cikk).",
          "Ülésátirataim és promptjaim továbbítása és feldolgozása az MI-szolgáltatónál (Anthropic), amelynek feldolgozási infrastruktúrája az EU/EGT-n kívül is elhelyezkedhet, az MI-válaszok előállítása céljából (KVKK 9. cikk).",
          "A szolgáltatás nyújtásához nem feltétlenül szükséges termékfejlesztési és elemzési célú adatkezelés.",
          "A szolgáltatással kapcsolatos értesítések fogadása.",
        ],
      },
      {
        heading: "A hozzájárulás visszavonása",
        paras: [
          "Tudomásul veszem, hogy kifejezett hozzájárulásomat bármikor visszavonhatom; mivel azonban az MI-szolgáltató részére történő külföldre továbbítás a szolgáltatás működéséhez technikailag szükséges, elfogadom, hogy a hozzájárulás visszavonása azzal járhat, hogy az érintett funkciókat vagy a szolgáltatás egészét nem tudom használni. A visszavonás nem érinti a visszavonás időpontjáig végzett adatkezelés jogszerűségét.",
        ],
      },
    ],
  },
  {
    // Counterpart of the TR "outreach" notice; see the comment there.
    id: "outreach",
    title: "Tájékoztató a megkereső kommunikációról",
    description:
      "Azoknak az akadémiai és intézményi kapcsolattartóknak, akik intézményi megkereső e-mailt kaptak: honnan származnak az adatok, miért kezeljük őket, mi a jogalap, és hogyan lehet leiratkozni.",
    updated: "2026-08-06",
    sections: [
      {
        paras: [
          "A jelen tájékoztató a PsyPractice által egyetemi pszichológia tanszékeknek és azok oktatóinak küldött intézményi megkereső e-mailek címzettjeit tájékoztatja a személyes adatok védelméről szóló 6698. számú török törvény (KVKK) 10. cikke, valamint a tájékoztatási kötelezettség teljesítésének eljárásáról és elveiről szóló közlemény alapján. Mivel személyes adatait nem közvetlenül Öntől szereztük be, a tájékoztatást legkésőbb az első kapcsolatfelvételkor adjuk meg; ezért hivatkozik ide a megkereső e-mail.",
        ],
      },
      {
        heading: "1. Adatkezelő",
        bullets: [
          `Név: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Cím: ${MERCHANT.addressEn}`,
          `Adóhivatal / adószám: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-mail: ${MERCHANT.email}`,
          `Web: ${MERCHANT.website}`,
        ],
      },
      {
        heading: "2. Kezelt adatok és forrásuk",
        paras: [
          "Az adatkezelés a szakmai kapcsolattartási adatokra korlátozódik: név, tudományos cím, egyetem és tanszék, intézményi e-mail-cím és, ha közzétették, intézményi telefonszám.",
          "Ezeket az adatokat nem Öntől gyűjtöttük, hanem az egyetemek nyilvánosan közzétett hivatalos tanszéki és kari oldalairól állítottuk össze. Különleges kategóriájú adatot nem kezelünk, és magán (nem intézményi) e-mail-címeket nem használunk megkeresésre.",
        ],
      },
      {
        heading: "3. Cél",
        paras: [
          "Adatait azért kezeljük, hogy bemutassunk egy pszichológushallgatók és pályakezdő klinikusok számára készült szoftvereszközt, meghívjuk tanszékét egy lehetséges pilotról vagy együttműködésről szóló beszélgetésre, és lebonyolítsuk az ezzel kapcsolatos levelezést. Az adatokat más célra nem használjuk, nem értékesítjük, és marketingcélból nem továbbítjuk harmadik feleknek.",
        ],
      },
      {
        heading: "4. Jogalap",
        paras: [
          "Az adatkezelés a KVKK 5. cikk (2) bekezdés f) pontja szerinti, az adatkezelő jogos érdekén alapul, feltéve, hogy ez nem sérti az Ön alapvető jogait és szabadságait: a kapcsolatfelvétel kizárólag intézményi címre, kizárólag a címzett szakterületéhez közvetlenül kapcsolódó ügyben és korlátozott számú alkalommal történik.",
          "Az, hogy az adatok az interneten nyilvánosan elérhetők, önmagában nem jogalap. A Személyes Adatok Védelmének Testülete kimondta, hogy az adatok nyilvános volta nem teszi őket bármilyen célra felhasználhatóvá, és a nyilvánosságra hozatal szándékát és célját külön kell mérlegelni; ezért az 5. cikk (2) bekezdés d) pontjára nem hivatkozunk.",
        ],
      },
      {
        heading: "5. Továbbítás és megőrzés",
        paras: [
          "A levelezést olyan e-mail-szolgáltatón keresztül folytatjuk, amelynek infrastruktúrája külföldön is elhelyezkedhet; az ilyen továbbítások a KVKK 9. cikke szerinti megfelelő garanciákkal történnek.",
          "Adatait a kapcsolatfelvétel céljának megszűnésekor vagy az Ön kérésére töröljük. Törlési kérelem után kizárólag egy szigorúan korlátozott „ne keressük” bejegyzést őrzünk meg, csak annak biztosítására, hogy többé ne keressük meg; ezt megkeresésre soha nem használjuk.",
        ],
      },
      {
        heading: "6. Kereskedelmi elektronikus üzenetek és a visszautasítás joga",
        paras: [
          "A promóciós üzenetek az elektronikus kereskedelem szabályozásáról szóló 6563. számú törvény hatálya alá tartoznak. Ezek fogadását indoklás nélkül visszautasíthatja; a visszautasításokat legkésőbb három munkanapon belül feldolgozzuk, ezt követően további promóciós üzenetet nem küldünk. Elegendő válaszolni a kapott e-mailre, vagy írni a(z) " + MERCHANT.email + " címre.",
        ],
      },
      {
        heading: "7. Az Ön jogai",
        paras: [
          "A KVKK 11. cikke alapján joga van megtudni, hogy személyes adatait kezelik-e, tájékoztatást kérni erről, megismerni az adatkezelés célját és azt, hogy az adatokat ennek megfelelően használják-e, megismerni azokat a harmadik feleket, akiknek az adatokat Törökországban vagy külföldön továbbítják, kérni a hiányos vagy pontatlan adatok helyesbítését, kérni az adatok törlését vagy megsemmisítését, kérni, hogy ezekről az intézkedésekről a harmadik feleket értesítsék, tiltakozni az Önre nézve hátrányos, kizárólag automatizált elemzésen alapuló eredmény ellen, valamint kártérítést követelni az elszenvedett kárért.",
          `A kérelmeket a(z) ${MERCHANT.email} címre küldheti; ezekre legkésőbb harminc napon belül válaszolunk. Fenntartja továbbá a jogot, hogy panaszt tegyen a Személyes Adatok Védelmének Testületénél.`,
        ],
      },
    ],
  },
  {
    id: "cookies",
    title: "Sütikre vonatkozó tájékoztató",
    description: "A használt sütik típusai, céljaik és a beállítások kezelése.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "A Platform sütiket és hasonló helyi tárolási technológiákat (localStorage) használ a munkamenet fenntartásához és a beállításai megjegyzéséhez.",
        ],
      },
      {
        heading: "Használt technológiák",
        bullets: [
          "Feltétlenül szükséges: munkamenet-/hitelesítési token, biztonság. Ezek nélkül a szolgáltatás nem működik.",
          "Funkcionális: nyelvi/területi beállítás (NEXT_LOCALE), felületi beállítások (pl. téma).",
          "Teljesítmény/biztonság: technikai naplók a sebességkorlátozáshoz és a visszaélések felismeréséhez.",
        ],
      },
      {
        heading: "A beállítások kezelése",
        paras: [
          "A sütiket a böngészőjében törölheti vagy letilthatja; a feltétlenül szükséges sütik letiltása azonban megakadályozza a bejelentkezést és az alapvető funkciók működését. A GDPR / ePrivacy elveivel és a KVKK süti-útmutatójával összhangban a nem alapvető sütiket kizárólag az Ön kifejezett beállítása/hozzájárulása alapján használjuk.",
        ],
      },
    ],
  },
  {
    id: "about",
    title: "Rólunk",
    description:
      "A PsyPractice célja, az általa nyújtott szolgáltatás és a kereskedő (eladó) elérhetőségei.",
    updated: LEGAL_VERSION,
    sections: [
      {
        paras: [
          "A PsyPractice MI-alapú pácienssimulációs és klinikaikészség-platform pszichológushallgatók, valamint frissen végzett, pályakezdő klinikusok számára. A felhasználók szöveges terápiás üléseket folytatnak; minden ülés végén egy szupervizor MI kiértékeli a beszélgetést, és fejlődést támogató visszajelző jelentést készít. A páciens MI az ülések közötti memória révén ülésről ülésre viszi tovább a terápiás kapcsolatot.",
        ],
      },
      {
        heading: "Küldetésünk",
        paras: [
          "Célunk, hogy a jövő mentálisegészség-szakembereinek biztonságos, ismételhető környezetet adjunk, amelyben a valódi kliensek veszélyeztetése nélkül gyakorolhatják a beszélgetésvezetést. A PsyPractice nem oktatási vagy tanítási szolgáltatás; szoftvereszköz, amellyel a felhasználó saját gyakorlását végzi és rögzíti. Nem valódi terápia vagy tanácsadás, nem helyettesíti a klinikai szupervíziót, nem diagnosztikai vagy értékelőeszköz, és krízisben vagy vészhelyzetben nem szabad használni.",
        ],
      },
      {
        heading: "Amit kínálunk",
        bullets: [
          "Szöveges terápiásülés-szimuláció a klinikai szakirodalomból összeállított, változatos páciensprofilokkal.",
          "Automatizált szupervizori értékelő jelentés minden ülés után.",
          "Ülések közötti memóriával rendelkező „élő páciens” modell, amely idővel fejleszti a terápiás kapcsolatot.",
          "Saját páciens létrehozása, amellyel a hallgatók saját MI-eseteket alkothatnak.",
          "A mikrokészségek fejlődését követő fejlődési mutatók.",
        ],
      },
      {
        heading: "Eladó / vállalkozás adatai",
        bullets: [
          `Kereskedelmi név: ${MERCHANT.legalName} (${OWNER_TYPE})`,
          `Cím: ${MERCHANT.addressEn}`,
          `Adóhivatal / adószám: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}`,
          `E-mail: ${MERCHANT.email}`,
          `Web: ${MERCHANT.website}`,
        ],
      },
    ],
  },
  {
    id: "distance-sales",
    title: "Távértékesítési szerződés",
    description:
      "Eladó, vevő, szolgáltatás, ár, fizetés, teljesítés és elállási jog a 6502. számú török törvény és a Távollévők közötti szerződésekről szóló rendelet alapján.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "1. Felek",
        bullets: [
          `ELADÓ: ${MERCHANT.legalName} (${OWNER_TYPE}). Cím: ${MERCHANT.addressEn}. Adóhivatal/adószám: ${MERCHANT.taxOffice} / ${MERCHANT.taxNo}. E-mail: ${MERCHANT.email}.`,
          "VEVŐ: az a természetes vagy jogi személy, aki a Platformon fiókot hoz létre, és fizetős előfizetést vásárol (a „Vevő”).",
        ],
      },
      {
        heading: "2. A szerződés tárgya",
        paras: [
          "A jelen Szerződés tárgya a felek jogainak és kötelezettségeinek meghatározása a fogyasztóvédelemről szóló 6502. számú török törvénnyel és a Távollévők közötti szerződésekről szóló rendelettel összhangban, a Vevő által a Platformon keresztül elektronikus úton megvásárolt, alább meghatározott jellemzőkkel és eladási árral rendelkező digitális szolgáltatási előfizetés értékesítésére és teljesítésére vonatkozóan.",
        ],
      },
      {
        heading: "3. A szolgáltatás jellege és ára",
        bullets: [
          "Az értékesített szolgáltatás a PsyPractice szoftver fizetős előfizetési csomagjában kínált, MI-alapú pácienssimulációs funkciók (digitális szolgáltatás / a szoftver használati joga).",
          "A PsyPractice nem oktatási vagy tanítási szolgáltatás; szoftvereszköz, amellyel a felhasználó saját gyakorlását végzi és rögzíti. Az előfizetési díj a szoftverhez való hozzáférés ellenértéke; nem órák, tanterv, vizsgák, tanácsadás vagy bármilyen dokumentum díja.",
          "A csomag tartalma, időtartama (havi, 4 hónapos időszak vagy éves) és aktuális ára a vásárlás pillanatában egyértelműen megjelenik a Platform ár-/fizetési oldalán; az adókat is tartalmazó teljes összeget a fizetés előtt közöljük a Vevővel.",
          "Az árak a Platformon megjelenített pénznemben érvényesek; lemondás hiányában az előfizetés a választott időszak végén ugyanazon az áron automatikusan megújul.",
          "A „korlátlan ülésként” kínált csomagoknál a használatra méltányos használati korlát vonatkozik (jelenleg naptári hónaponként 60 ülés). A korlát elérése után a következő naptári hónap első napjától lehet ismét új ülést indítani; ez nem jogosít árcsökkentésre vagy visszatérítésre. A korlát a fiókmegosztás és az automatizált használat megakadályozását szolgálja, és az Eladó a kifizetett előfizetési időszak alatt nem módosítja azt a Vevő hátrányára.",
        ],
      },
      {
        heading: "4. Fizetés",
        paras: [
          "A fizetéseket az engedéllyel rendelkező iyzico fizetési intézmény szedi be biztonságosan, hitel-/betéti kártyával. A kártyaadatokat az Eladó nem tárolja; a fizetést az iyzico biztonságos rendszerein keresztül dolgozzuk fel. Ismétlődő (előfizetéses) fizetés esetén az összeget minden megújítási időszakban automatikusan terheljük a Vevő által jóváhagyott kártyára.",
        ],
      },
      {
        heading: "5. Teljesítés és átadás",
        paras: [
          "A szolgáltatás digitális, és nem jár fizikai kézbesítéssel. A fizetés visszaigazolását követően az előfizetéses funkciók azonnal elérhetővé válnak a Vevő fiókjában. A teljesítés elektronikus úton, az előfizetési időszak alatt folyamatos hozzáférés biztosításával történik.",
        ],
      },
      {
        heading: "6. Elállási jog és annak kivétele",
        bullets: [
          "A Távollévők közötti szerződésekről szóló rendelet 15. cikk (1) bekezdés ğ) pontja alapján az elállási jog nem gyakorolható olyan, elektronikus úton azonnal teljesített, nem tárgyi (digitális) áruk/szolgáltatások esetében, amelyek teljesítése a Vevő hozzájárulásával megkezdődött.",
          "A Vevő a vásárláskor tudomásul veszi, hogy a szolgáltatás teljesítése azonnal megkezdődik, és ezért elállási jog nem áll fenn. A Vevő az előfizetést bármikor lemondhatja a megújítás leállítása érdekében; a lemondás az aktuális fizetett időszak végén lép hatályba.",
          "A részletes visszatérítési feltételeket lásd: „Teljesítési és visszatérítési feltételek”.",
        ],
      },
      {
        heading: "7. Jogviták és hatálybalépés",
        paras: [
          "Jogvita esetén a Vevő a Kereskedelmi Minisztérium által közzétett értékhatárokon belül a lakóhelye szerinti Fogyasztói Választottbírósági Bizottsághoz vagy a fogyasztói bíróságokhoz fordulhat. A jelen Szerződés a Vevő elektronikus úton adott jóváhagyásával jön létre és lép hatályba.",
        ],
      },
    ],
  },
  {
    id: "delivery-refund",
    title: "Teljesítési és visszatérítési feltételek",
    description:
      "A digitális szolgáltatás teljesítése, az előfizetés lemondása, az elállási kivétel és a visszatérítés feltételei.",
    updated: LEGAL_VERSION,
    sections: [
      {
        heading: "Teljesítés (digitális szolgáltatás)",
        bullets: [
          "A PsyPractice teljes egészében digitális szolgáltatás; nincs fizikai termékszállítás vagy futáros kézbesítés.",
          "A fizetés visszaigazolásának pillanatában az előfizetéses funkciók automatikusan és azonnal aktiválódnak a Vevő fiókjában; nincs külön teljesítési idő vagy szállítási díj.",
          "A szolgáltatás bármely internetkapcsolattal rendelkező eszköz böngészőjéből elérhető.",
        ],
      },
      {
        heading: "Az előfizetés lemondása",
        bullets: [
          "A Vevő az előfizetést bármikor lemondhatja a fiókbeállításokban. A lemondás az aktuális fizetett időszak végén lép hatályba, és leállítja a következő automatikus megújítást.",
          "A lemondás után a szolgáltatáshoz való hozzáférés a fizetett időszak hátralévő részében folytatódik.",
        ],
      },
      {
        heading: "Elállási jog és visszatérítés",
        bullets: [
          "Mivel a szolgáltatás a Vevő hozzájárulásával azonnal teljesített digitális szolgáltatás, a Távollévők közötti szerződésekről szóló rendelet 15. cikk (1) bekezdés ğ) pontja alapján főszabály szerint nem keletkezik elállási jog, és így visszatérítési jog sem.",
          "Egyértelmű hiba esetén, például téves/kétszeres terhelés, a szolgáltatás technikai okból való teljes elérhetetlensége vagy hasonló esetben a Vevő a fizetés napjától számított ésszerű időn belül az Eladóhoz fordulva visszatérítést kérhet.",
          `A visszatérítési kérelmeket a(z) ${MERCHANT.email} címre kell küldeni; a jóváhagyott visszatérítéseket az iyzico infrastruktúráján keresztül, főszabály szerint 14 napon belül, a fizetéshez használt kártyára utaljuk vissza. A visszatérítés időtartama a bank feldolgozási idejétől függően eltérhet.`,
        ],
      },
      {
        heading: "Kapcsolat",
        paras: [
          `Minden teljesítési, lemondási és visszatérítési ügyben: ${MERCHANT.email}${MERCHANT.phone ? " · " + MERCHANT.phone : ""}.`,
        ],
      },
    ],
  },
];
